import request from '@/services/base-service';
import type { RequestDTO, SaveFishboneDiagramRequest } from '@/types/performance/buoc5';
import type { CoCauHistoryStrategyMapRequest } from '@/types/performance/buoc4congty';
import { InternalAxiosRequestConfig } from 'axios';
//PORT 7251

// const baseurl = "https://localhost:7251/api/v1/performance"
const baseurl = "/v1/performance"
export const fishboneApi = {
  /**
   * Get Fishbone data for buoc5
   * @param requestDTO - Request parameters including year and selectTree
   * @returns Promise with fishbone data
   */

  // port 7251
    getFishbone: (requestDTO: RequestDTO) =>
    request.post(
      `${baseurl}/getfishbone`,
      requestDTO,
      { authorization: true } as InternalAxiosRequestConfig
    ),

    getFishboneCoCauHistory: (requestDTO: CoCauHistoryStrategyMapRequest) =>
      request.post(
        `${baseurl}/getfishbone-cocau-history`,
        requestDTO,
        { authorization: true } as InternalAxiosRequestConfig
      ),

  /**
   * Get specific Fishbone data by head objective ID
   * @param site - Site identifier
   * @param idPhuTrach - Department ID
   * @param year - Year
   * @param phanhe - System module
   * @param idmuctieu - Head objective ID (optional)
   * @param idkpichoice - KPI choice ID (optional)
   * @param idgiaidoan - Period ID (optional)
   * @returns Promise with specific fishbone data
   */
    getFishboneById:  (requestDTO: RequestDTO) =>
      request.post(
        `${baseurl}/getfishbone`,
        requestDTO,
        { authorization: true } as InternalAxiosRequestConfig
      ),

    /** Fishbone theo mục tiêu (dashboard / báo cáo) — backend GetFishboneByTarget */
    getFishboneByTarget: (requestDTO: RequestDTO) =>
      request.post(
        `${baseurl}/getfishbonebytarget`,
        requestDTO,
        { authorization: true } as InternalAxiosRequestConfig
      ),

    /** Báo cáo xưởng cá (dashboard / báo cáo) — backend BaoCaoXuongCa */
    baoCaoXuongCa: (requestDTO: RequestDTO) =>
      request.post(
        `${baseurl}/baocaoxuongca`,
        requestDTO,
        { authorization: true } as InternalAxiosRequestConfig
      ),

    saveFishbone: (requestDTO: SaveFishboneDiagramRequest) =>
      request.post(
        `${baseurl}/savefishbone`,
        requestDTO,
        { authorization: true } as InternalAxiosRequestConfig
    ),
  getTooltipKPI: (requestDTO: RequestDTO) =>
    request.post<string>(
      `${baseurl}/gettooltipkpi`,
      requestDTO,
      { authorization: true } as InternalAxiosRequestConfig
    ),
  checkTonTaiKPIChoice: (requestDTO: RequestDTO) =>
    request.post<boolean>(
      `${baseurl}/check-ton-tai-kpichoice`,
      requestDTO,
      { authorization: true } as InternalAxiosRequestConfig
    ),

};
